import {
  EnumSurveyQuestionType,
  type Maybe,
  type Multilingual,
} from "gql/generated";

export type SurveyQuestionLike = {
  type?: Maybe<EnumSurveyQuestionType | string>;
  name?: Maybe<Multilingual>;
};

export const SURVEY_DESIGN_FIELD_TYPES = [
  EnumSurveyQuestionType.SectionHeading,
  EnumSurveyQuestionType.CustomText,
] as const;

export function isSurveyDesignFieldType(
  type?: Maybe<EnumSurveyQuestionType | string>,
): boolean {
  return (
    type === EnumSurveyQuestionType.SectionHeading ||
    type === EnumSurveyQuestionType.CustomText
  );
}
